module.exports = __webpack_public_path__ + "img/egg_circles_happy.e78dd55c.svg";